import React, { useEffect, useState, useRef } from "react";
import { getCompanyResponses } from "../../../utils/api/submissions";
import Loader from "../../custom-components/Loader/Loader";
import { IoClose } from "react-icons/io5";
import { HttpStatusCode } from "axios";

function CompanyResponse({ companyId }) {
  const [formResponses, setFormResponses] = useState([]);
  const [selectedResponse, setSelectedResponse] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const tableBodyRef = useRef(null);
  const lastRowRef = useRef(null);

  const openModal = (responses) => {
    setSelectedResponse(responses);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedResponse(null);
  };

  useEffect(() => {
    getCompaniesData();
  }, [page]);

  useEffect(() => {
    if (lastRowRef.current) {
      console.log("Scrolling to last row");
      lastRowRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [formResponses]);

  const getCompaniesData = async () => {
    setLoading(true);
    try {
      const result = await getCompanyResponses(companyId, page, 10);
      if(result.status === HttpStatusCode.Ok){
        const newResponses = result.data.data;

        if (newResponses.length < 10) {
          setHasMore(false);
        }

        setFormResponses((prevResponses) => [
          ...prevResponses,
          ...newResponses,
        ]);
      }
      
    } catch (err) {
      console.log(err);
      setFormResponses([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-[800px]">
      <div>
        <div className="flex gap-2">
          <h1 className="mb-4 text-2xl font-semibold">Company Responses</h1>
        </div>
        {!loading ? (
          formResponses?.length > 0 ? (
            <>
              <div className="overflow-auto max-h-[400px]" ref={tableBodyRef}>
                <table className="min-w-full text-center border border-collapse border-gray-300 shadow-lg table-auto">
                  <thead className="bg-gray-200">
                    <tr>
                      <th className="py-3 border-b">Employee Name</th>
                      <th className="py-3 border-b">Employee Email</th>
                      <th className="py-3 border-b">Form Name</th>
                      <th className="py-3 border-b">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formResponses.map((responses, index) => (
                      <tr
                        key={index}
                        className={`transition duration-200 hover:bg-gray-100 ${
                          index % 2 === 0 ? "bg-gray-100" : "bg-white"
                        }`}
                        ref={
                          index === formResponses.length - 1 ? lastRowRef : null
                        }
                      >
                        <td className="py-2 border-b">
                          {responses.employee.name}
                        </td>
                        <td className="py-2 border-b">
                          {responses.employee.email}
                        </td>
                        <td className="py-2 border-b">
                          {responses.company.form.name}
                        </td>
                        <td className="py-2 border-b">
                          <button
                            className="px-4 py-2 font-semibold text-white transition duration-200 ease-in-out transform bg-blue-600 border rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 hover:scale-105"
                            onClick={() => openModal(responses)}
                          >
                            Show Response
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {hasMore && !loading && (
                <button
                  onClick={() => setPage((prev) => prev + 1)}
                  className="w-full py-2 mt-4 text-white bg-blue-500 hover:bg-blue-600"
                >
                  Load More
                </button>
              )}

              {isModalOpen && selectedResponse && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                  <div className="w-1/3 p-6 bg-white overflow-y-auto h-[80%] rounded-lg shadow-lg relative">
                    <span
                      onClick={closeModal}
                      className="absolute top-2 right-2 text-white cursor-pointer text-sm px-2 py-[2px] bg-black border-l border-b border-gray-600 rounded-es-lg hover:text-gray-300 hover:bg-gray-700 transition-all"
                    >
                      <IoClose size={18} />
                    </span>

                    <h2 className="mb-4 text-xl font-bold">
                      Responses for {selectedResponse.employee.name}
                    </h2>

                    <div className="space-y-4 max-h-[70vh] overflow-y-auto">
                      {selectedResponse.response.map((field, fieldIndex) => (
                        <div key={fieldIndex} className="flex flex-col">
                          <label className="font-semibold">
                            {field.fieldName}
                          </label>
                          <input
                            className="px-2 py-1 border rounded-md"
                            type="text"
                            value={field.fieldValue}
                            readOnly
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
            <p>No responses found</p>
          )
        ) : (
          <div className="my-28">
            <Loader size={"w-24 h-24"} />
          </div>
        )}
      </div>
    </div>
  );
}

export default CompanyResponse;
